<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          虚拟条码：<span v-if="formData.billNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.billNo
          }}</span>
          <span v-else class="information"> 待生成</span>
          <!-- 状态 -->
          <span v-if="!dataId" class="information"> 新增</span>
          <span v-else class="information">
              {{
              formData.stat == '0' ? '制单' : formData.stat == '1' ? '制单' : formData.stat == '2' ? '审核中' : formData.stat ==
              '5' ? '已审核' : formData.stat == '6' ? '驳回' : formData.stat == '99' ? '取消' : '取消'
            }}</span>
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="editButton && (formData.stat == 1 || formData.stat == 6)"
                     @click="saveData">保存
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check"
                     v-if="formData.id!=null&&(formData.stat==1)&&!formData.processId&&submitButton"
                     @click="showCloseDialog = true;type='提交'">提交
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-s-claim"
                     v-if="formData.id!=null&&formData.stat == 2&&!formData.processId&&checkButton"
                     @click="showCloseDialog = true;type='审核'">审核
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-bottom"
                     v-if="formData.id!=null&&formData.stat == 2&&!formData.processId&&rejectButton"
                     @click="showCloseDialog = true;type='驳回'">驳回
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-close"
                     v-if="formData.id!=null&&(formData.stat==1||formData.stat==6)&&!formData.processId&&cancelButton"
                     @click="showCloseDialog = true;type='取消'">取消
          </el-button>
        </div>
      </div>

      <div>

        <dix style="overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important;display: block ">
          <div>
            <!-- 品牌信息 -->
            <div class="d-cont edit-mce-box" style="height: 100%;margin:0 !important;padding:0 !important;">
              <div class="d-item">
                <div class="title first">
                  <b>主信息</b>
                </div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        部门名称
                      </th>
<!--                      <td v-if="this.currentSiteData!==null">
                        <el-cascader v-model="orgValue" :options="orgOptions" @change="orgHandleChange" :disabled="true" />
                      </td>
                      <td v-else>
                        <el-cascader v-model="orgValue" :options="orgOptions" @change="orgHandleChange"/>
                      </td>-->

                      <td v-if="this.currentSiteData===null">
                        <el-input placeholder="请选择" v-model="formData.orgName"   readonly >
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="assignOrg"></i>
                        </el-input>
                      </td>
                      <td v-else>
                        <el-input placeholder="请选择" v-model="formData.orgName"   readonly  :disabled="true">
                          <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                      </td>

                      <th>
                        <em class="f-red">*</em>
                        网点名称
                      </th>
                      <td v-if="this.currentSiteData!==null">
                        <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable :disabled="true">
                          <i slot="suffix" class="el-input__icon el-icon-search"></i>
                        </el-input>
                      </td>
                      <td v-else>
                        <el-input type="text" autocomplete="off" v-model="formData.siteName" clearable>
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showSitePop = true"></i>
                        </el-input>
                      </td>
                      <th>
                        联系人
                      </th>

                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.siteMan" clearable />
                      </td>
                      <th>
                        联系人电话
                      </th>

                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.siteMobile" clearable />
                        <!-- <el-input type="text" autocomplete="off" v-model="callMobile1" clearable /> -->

                      </td>
                      </tr>
                    <tr>
                      <th>
                        异常条码
                      </th>
                      <td style="position: relative;">
                        <el-input type="text"  v-model="formData.barcode" disabled clearable />
<!--                        <span style="position: absolute;right:-15px;top: 12px;" class="Instructions" v-on:click="createVirtualBarcode">生成</span>-->
                      </td>
                      <th>
                        条码异常类型
                      </th>
                      <td style="position: relative;">
                        <el-input type="text"  v-model="formData.exceptionBarcodeName" disabled clearable />
                        <!--                        <span style="position: absolute;right:-15px;top: 12px;" class="Instructions" v-on:click="createVirtualBarcode">生成</span>-->
                      </td>
                      <th>
                        品牌
                      </th>
                      <td style="position: relative;">
                        <el-input type="text"  v-model="formData.brandName" disabled clearable />
                        <!--                        <span style="position: absolute;right:-15px;top: 12px;" class="Instructions" v-on:click="createVirtualBarcode">生成</span>-->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first">
                  <b>申请信息</b>
                </div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        关联工单
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.orderNo" :readonly="true" clearable>
                          <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialogFunc"></i>
                        </el-input>
                      </td>
                      <th>
                        服务类型
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.serviceTypeName" :disabled="true" clearable />
                      </td>
                      <th>
                        用户姓名
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.userName" :disabled="true" clearable />
                      </td>
                      <th>
                        用户电话
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.userMobile" :disabled="true" clearable />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>产品条码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.barcode" clearable @blur="barcodeBlur" @change="barcodeChange" />
                      </td>
                      <th>
                        产品编码
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.itemCode" :disabled="searchItemButton" clearable
                          readonly >
                        <i slot="suffix" class="el-input__icon el-icon-search" v-if="!this.searchItemButton"
                            @click="showPreconditionDialog = true"></i>
                        </el-input>
                      </td>
                      <th>
                        产品名称
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.itemName" :disabled="true" clearable />
                      </td>
                      <th>
                        产品分类
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.categoryName" :disabled="true" clearable />
                      </td>
                    </tr>
                    <tr>
                      <th>
                        购买日期
                      </th>
                      <td>
                        <el-date-picker v-model="formData.buyDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss"
                          type="date" placeholder="选择日期">
                        </el-date-picker>
                      </td>
                      <th>
                        经销商
                      </th>
                      <td>
                        <el-input type="text" autocomplete="off" v-model="formData.buySaler" clearable />
                      </td>
                      <th>
                        条码使用情况
                      </th>
                      <td colspan="3" style="position: relative;">
                        <el-input type="text" autocomplete="off" v-model="formData.applyRemark" :disabled="true" clearable >
                          <!-- <span style="position: absolute;right:-15px;top: 12px;" class="Instructions" v-on:click="checkBarcode">检测</span> -->
                        </el-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-item" style="position: relative;">
                <div class="title first" style="    display: flex;justify-content: space-between;align-items: center;">
                  <b>回访情况</b>
                  <el-button type="primary" class="button-sty btn_zdy" @click="showOrderRemaek(); starLevelObj = null" style="position: absolute;right: 0;">
                      <i class="el-icon-plus"></i>
                      增加回访
                    </el-button>
                </div>
                <vxe-table :stripe="true"
                    :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                    :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                    show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                    :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                    :data="formData.virtualBarcodeBillRecalls">


                    <vxe-column type="seq" title="序号" width="60" />
                    <vxe-column title="回访情况" width="110">
                      <template #default="{ row }">
                        <span v-if="row.huiFangQingKuang == 1">属实</span>
                        <span v-if="row.huiFangQingKuang == 2">不属实</span>
                        <span v-if="row.huiFangQingKuang == 3">不确定</span>
                        <span v-if="row.huiFangQingKuang == 4">用户产品已退换货</span>
                        <span v-if="row.huiFangQingKuang == 19">其他</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="passReason" title="通过/不通过原因" width="150">
                      <template #default="{ row }">
                        <span v-if="row.passReason == 1">查询条码录错被占用</span>
                        <span v-if="row.passReason == 2">存在二次销售记录</span>
                        <span v-if="row.passReason == 3">条码存在不同服务地址</span>
                        <span v-if="row.passReason == 4">条码不存在条码库但有WMS系统记录</span>
                        <span v-if="row.passReason == 19">其他</span>
                        <span v-if="row.passReason == 21">未购机</span>
                        <span v-if="row.passReason == 22">未安装</span>
                        <span v-if="row.passReason == 23">空号</span>
                        <span v-if="row.passReason == 24">停机</span>
                        <span v-if="row.passReason == 29">其他</span>
                      </template>
                    </vxe-column>
<!--                    <vxe-column field="barcodeError" title="条码是否异常" width="60">-->
<!--                      <template #default="{ row }">-->
<!--                        <span v-if="row.barcodeError == 0">否</span>-->
<!--                        <span v-if="row.barcodeError == 1">是</span>-->
<!--                      </template>-->
<!--                    </vxe-column>-->
                    <vxe-column field="recallMan" title="回访员" width="110" />
                    <vxe-column field="recallDate" title="回访时间" width="110" />
                    <vxe-column title="操作" width="50">
                      <template #default="{ row }">
                        <a href="javascript:void(0);" class="a-link" @click="deleteRecalls(row)">
                          <el-tooltip effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
                            <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>
                        </a>
                      </template>
                    </vxe-column>
                  </vxe-table>
              </div>

              <div class="d-item" style="position: relative;">
                <div class="title first" style="    display: flex;justify-content: space-between;align-items: center;">
                  <b>技术审核一:</b>
                </div>
                <vxe-table :stripe="true"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                           show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                           :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :data="virtualBarcodeBillCheck1">


                  <vxe-column type="seq" title="序号" width="60" />
                  <vxe-column title="审核结果" width="110">
                    <template #default="{ row }">
                      <span v-if="row.checkResult == 1">通过</span>
                      <span v-if="row.checkResult == 2">不通过</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="passReason" title="通过/不通过原因" width="150">
                    <template #default="{ row }">
                      <span v-if="row.passReason == 1">附件上传合格,查询条码被占用</span>
                      <span v-if="row.passReason == 2">存在二次销售记录</span>
                      <span v-if="row.passReason == 3">附件上传合格,条码不存在条码库,有WMS系统记录</span>
                      <span v-if="row.passReason == 19">其他</span>
                      <span v-if="row.passReason == 21">条码录错</span>
                      <span v-if="row.passReason == 22">上传附件不合格</span>
                      <span v-if="row.passReason == 23">条码或产品非正品</span>
                      <span v-if="row.passReason == 29">其他</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="checkRemark" title="备注" width="110" />
<!--                  <vxe-column field="barcodeError" title="条码是否异常" width="60">-->
<!--                    <template #default="{ row }">-->
<!--                      <span v-if="row.barcodeError == 0">否</span>-->
<!--                      <span v-if="row.barcodeError == 1">是</span>-->
<!--                    </template>-->
<!--                  </vxe-column>-->
                </vxe-table>
              </div>

              <div class="d-item" style="position: relative;">
                <div class="title first" style="    display: flex;justify-content: space-between;align-items: center;">
                  <b>技术审核二</b>
                </div>
                <vxe-table :stripe="true"
                           :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                           :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                           show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                           :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                           :data="virtualBarcodeBillCheck2">


                  <vxe-column type="seq" title="序号" width="60" />
                  <vxe-column title="审核结果" width="110">
                    <template #default="{ row }">
                      <span v-if="row.recheckResult == 1">旧工单为假产品</span>
                      <span v-if="row.recheckResult == 2">新工单为假产品</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="passReason" title="机器是否需要返厂" width="150">
                    <template #default="{ row }">
                      <span v-if="row.recheckMachineReturn == 0">否</span>
                      <span v-if="row.recheckMachineReturn == 1">是</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="recheckRemark" title="备注" width="110" />
<!--                  <vxe-column field="barcodeError" title="条码是否异常" width="60">-->
<!--                    <template #default="{ row }">-->
<!--                      <span v-if="row.barcodeError == 0">否</span>-->
<!--                      <span v-if="row.barcodeError == 1">是</span>-->
<!--                    </template>-->
<!--                  </vxe-column>-->
                </vxe-table>
              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;align-items: center;">
                  <div class="title first"><b>附件列表</b></div>
                  <el-upload style="display:flex; float: right"
                             class="upload-demo"
                             ref="upload"
                             :action="api.uploadFileUrl"
                             accept=".pdf,.jpg,.png,.jpeg"
                             :limit="6"
                             :show-file-list="false"
                             :on-success="(res,file, fileList) => {handleFileSuccess(res,file, fileList)}"
                             :on-progress="upVideo"
                             :headers="headers"
                             :auto-upload="true"
                  >
                    <el-button type="primary" class="button-sty btn_zdy">
                      <i class="el-icon-plus"></i>
                      附件
                    </el-button>
                  </el-upload>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                             :header-cell-style="{ height: '36px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                             :row-config="{ height: 36, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                             show-overflow height="210" :column-config="{ resizable: true }" @checkbox-change="selectChangeEvent"
                             @checkbox-all="selectChangeEvent" :data="formData.fileList">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="fileName" title="附件名称" width="400">
                      <template #default="{row}">
                          <!-- <a :href="row.fileUrl" :download="row.fileName">{{row.fileName}}</a> -->
                          <span @click="openVideo(row.fileUrl)">{{ row.fileName }}</span>

                        </template>
                    </vxe-column>
                    <vxe-column title="操作" width="90">
                      <template #default="{row}">
                        <div>
                          <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                      popper-class="tooltip-skin">
                            <i @click="deleteFile(row)" class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                          </el-tooltip>

                        <el-tooltip :enterable="false" effect="dark" content="下载" placement="top"
                            popper-class="tooltip-skin">
                            <i @click="handleDownload(row.fileName, row.fileUrl)" class="el-icon-download"
                              style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
                          </el-tooltip>

                          <el-tooltip :enterable="false" effect="dark" content="预览文件" placement="top"
      popper-class="tooltip-skin">
      <i @click="openVideo(row.fileUrl)" class="el-icon-view"
        style="font-size: 18px; color: #00c4b3;    margin-left: 10px;"></i>
    </el-tooltip>
                        </div>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>
              <wfView  visible-key="showEdit" :wfData="wfData" :parent-target="_self"
              @reloadWf="reloadWf"></wfView>

              <div style="height:290px"></div>
            </div>
          </div>
        </dix>
      </div>
    </el-form>

    <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList" />

    <sitePop v-if="showSitePop" :visiable.sync="showSitePop" :multi="true" @commit="siteCommit" :orgId="formData.orgId" multi="true"/>

    <orderPop v-if="showOrderPop" :visiable.sync="showOrderPop" multi="false" @commit="orderCommit" :paramForQuery="true" :unFlash="1"
              :siteId="formData.siteId" :rhs="true" />

    <closeDialog v-if="showCloseDialog"
                 :dataId="formData.id"
                 :confirmNo="formData.billNo"
                 :type="type"
                 @closeD="closeD"
                 :visiable.sync="showCloseDialog"
                 multi="true"
                 @goBackIndex="goBackIndex"
    />

    <confirmDialog v-if="showConfirmDialog" :confirmNo="formData.billNo" :dataId="dataId" @closeD="closeD"
      :visiable.sync="showConfirmDialog" multi="true" @flushed="editViewDataUpdate" />

    <auditDialog v-if="showAuditDialog" :dataId="dataId" @closeD="closeD" :visiable.sync="showAuditDialog" multi="true"
      @flushed="editViewDataUpdate" />
      <!-- 回访-->
      <orderRemark v-if="showOrderRemaekDialog" @followUpOrderRemark="followUpOrderRemark" :visiable.sync="showOrderRemaekDialog"
                 :param="orderRemarkParam"/>
                           <!-- 文件预览 -->
    <Preview v-if="showPreview" @closeD="closeD2" :visiable.sync="showPreview" :imgVisbleURL="imgVisbleURL" />

    <!-- 中心弹框 -->
    <assignDialog v-if="showOrgDialog" @commitOrgSelect="commitOrgSelect"
                  :visiable.sync="showOrgDialog" multi="true" />

    <!-- 产品弹窗 -->
    <preconditionDialog v-if="showPreconditionDialog" @commitSelectedRow="commitSelectedRow"
      :visiable.sync="showPreconditionDialog" multi="true" />
  </div>
</template>
<script>
// 产品弹窗
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import checkSubjectSearch from "@/components/formItem/checkSubjectSearch.vue"
import Tinymce from '@/components/Tinymce';
import store from "@/store";
import api from '@/api/projectApi'
import { uploadFileFormat, echoFileFormat } from '@/util/uploadFormat'
import sitePop from "@/views/dialogCommon/radioSiteDialog.vue"
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import auditDialog from "@/views/expense/assessment/assessment1/auditDialog.vue";
import confirmDialog from "@/views/expense/assessment/assessment1/confirmDialog.vue";
import closeDialog from "@/views/expense/business/barcodeApplication/closeDialog.vue";
import DictSelect from "@/components/formItem/dictSelect.vue";
import { mapGetters } from "vuex";
import {siteMixins} from "@/mixins/tabChang";
// 回访
import orderRemark from "./starLevel.vue";
// 流程
import wfView from "@/views/dialogCommon/wfMsgDialog.vue";
// 文件预览
import Preview from "@/views/dialogCommon/PreviewDialog.vue";
import {fetchTree} from "@/api/admin/type_tree";
import assignDialog from "@/views/dialogCommon/orgDialog";
export default {
  mixins: [siteMixins],
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    processId: [String, Number],
    type: String,
  },
  components: {
    assignDialog,
    Preview,
    wfView,
    orderRemark,
    DictSelect,
    checkSubjectSearch,
    closeDialog, confirmDialog, auditDialog,
    sitePop,
    Tinymce,
    orderPop,
    preconditionDialog,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  data() {
    return {
      searchItemButton: true,
      showPreconditionDialog: false,
      imgVisbleURL: '',
      showOrgDialog:false,
      showPreview: false,
            // 号码验证
            callMobile1: '',
      recallButton: false,
      editButton: true,
      selectedData: [],
      orgOptions: [],
      //orgValue:'',
      showOrderRemaekDialog: false,
      orderRemarkParam:{},

      hasBarcode: false,

      loading: false,
      // 流程
      processId: '',

      wfData: {
        wfEntityId: ''
      },
      initiateAppeal: false,
      formLabelWidth: '80px',
      justShow: false,
      showCloseDialog: false,
      showConfirmDialog: false,
      showAuditDialog: false,
      isSite: null,

      dialogImageUrlList: [],
      dialogVisible: false,
      uploadFileUrl: api.uploadFileUrl,

      form2: {
        appealRemark: '',
        siteAnswerNote: '',
      },
      virtualBarcodeBillCheck1:[],
      virtualBarcodeBillCheck2:[],
      formData: {
        id: null,
        fileList: [],
        virtualBarcodeBillRecalls:[],
        checkSubjectName: '',
        infoSource: null,
        infoSourceName: null,
        billNo: '',  // 考核单号,前缀"CK"+年月日+6位流水号
        stat: 1,  // 状态：1制单；2.待确认；3待申诉；5已申诉；7执行考核；9已结算；19取消执行；99关闭
        orgId: 0,  // 业务机构，关联脚手架机构表.id
        orgName: '',  // 机构名称,冗余字段
        orgIdPath: '',  // 机构ID路径,冗余字段.重要
        siteId: null,  // 网点ID,关联sn_user.id;
        siteName: '',  // 网点名称,冗余字段
        brandId: '',  // 品牌ID,关联sn_company_brand.id
        brandName: '',  // 品牌名称,冗余字段
        orderId: '',  // 工单id，关联so_order.id.非必填
        orderNo: '',  // 工单号，冗余字段

        checkResult: null, // 审批结果:1申诉成立;2申诉不成立
        checkMan: '',  // 最终审批人
        checkAmount: '',  // 最终审批金额(结算时使用此金额)
        checkDate: '',  // 最终审批时间
        checkNote: '',  // 最终审批意见

        virtualBarcode: '',//虚拟条码
        virtualBarcodeFlag: '',//虚拟条码
        exceptionBarcodeName:'',//条码异常类型

        categoryName: '',
        bigCategoryId: null,
        bigCategoryName: '',
        smallCategoryId: null,
        smallCategoryName: '',
        buyDate: null, //购买日期
        itemId: null,//产品id
        applyReason: "异常条码申请",
        buySaler: '', //经销商
        applyRemark:'',
        barcode: '',
        siteMobile: '',
        siteMan: '',
      },
      picList1: [],
      picList2: [],
      picList3: [],
      picList4: [],
      picList5: [],
      picList6: [],
      showPhotoList0: [],
      showPhotoList1: [],
      operationDTOList: [],

      showPhoto: true,
      checkSubjectOption: [],
      brandOptions: [],
      showSitePop: false,

      showProductCategoryDialog: false,
      showOrderPop: false,

      upload_btn1: true,
      upload_btn2: true,
      upload_btn3: true,

      radio: '1',
      showEdit: false,

      activeName: 'first',
      dialog: {
        one: false,
      },
      isEdit: false,
      dataId: '',
    };
  },
  watch: {
        // 联系方式验证
    //     callMobile1: {
    //   handler(newVal, oldVal) {

    //     this.formData.siteMobile = newVal

    //     var numReg = /^[0-9]+$/
    //     var numRe = new RegExp(numReg)
    //     if (!numRe.test(this.formData.siteMobile)) {
    //       this.$message.error("请输入正确的11位手机号码");
    //     } else if (this.formData.siteMobile.length > 11) {
    //       this.$message.error("手机号码不能超过11位");
    //       this.formData.siteMobile = this.formData.siteMobile.slice(0, 11);
    //       this.callMobile1 = this.formData.siteMobile
    //     }
    //   },
    //   deep: true,
    // },
    'formData.adjustAmount': {
      handler(newVal, oldVal) {
        if (this.formData.standardAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.standardAmount': {
      handler(newVal, oldVal) {
        if (this.formData.adjustAmount !== '' && !this.justShow) {
          let number = Number(this.formData.adjustAmount) + Number(this.formData.standardAmount);
          this.formData.checkAmount = Math.round(number * 100) / 100
          this.formData.amount = this.formData.checkAmount
        }
      },
      deep: true, // 加这个属性，深度监听
    },
    'formData.checkSubjectId': {
      deep: true,
      handler(newVal) {
        this.checkSubjectSelectOne()
      }
    }
  },

  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    if (this.processId && !isNaN(this.processId)) this.wfData.wfEntityId = this.processId;
    this.editButton = this.permissions["wkVirtualBarcodeBillEdit"];
    this.submitButton= this.permissions["wkVirtualBarcodeBillSubmit"]; //提交
    this.checkButton= this.permissions["wkVirtualBarcodeBillCheck"]; //审核
    this.rejectButton= this.permissions["wkVirtualBarcodeBillReject"]; //驳回
    this.cancelButton= this.permissions["wkVirtualBarcodeBillCancel"]; //取消
    this.recallButton= this.permissions["wkVirtualBarcodeBillFollowUp"]; //回访
    console.log("权限",JSON.stringify(this.permissions))
  },

  mounted() {
    this.loadLoginIsSite()
    //this.loadOrgData()
    this.getData()
  },

  methods: {
    barcodeChange(){
      this.formData.virtualBarcode = ''
      this.formData.virtualBarcodeFlag = ''
      this.formData.exceptionBarcodeName = ''
    },
    barcodeBlur(){
      this.formData.applyRemark = ''
      this.searchItemButton = true
      this.checkBarcode()
    },
    commitSelectedRow(data) {
      console.log(data, 'data传过来的值  编码');
      this.formData.itemId = data.id
      this.formData.itemCode = data.itemCode
      this.formData.itemName = data.itemName
      this.formData.bigCategoryId = data.bigCategoryId
      this.formData.bigCategoryName = data.bigCategoryName
      this.formData.categoryName = data.bigCategoryName + (data.smallCategoryName ? ("/" + data.smallCategoryName) : '')
      this.formData.smallCategoryId = data.smallCategoryId
      this.formData.smallCategoryName = data.smallCategoryName
    },
    //点击选择部门
    assignOrg(){
      this.showOrgDialog=true
    },

    commitOrgSelect(data){
      this.formData.orgId = data.id;
      this.formData.orgName = data.name;
      this.formData.orgIdPath = data.orgIdPath;
    },

    closeD2() {
      this.showPreview = false
    },
    // 文件下载
    handleDownload(Vname, Vurl) {
      console.log(Vname, Vurl, "文件下载");
      // let url=file.type
      let url = Vurl
      let name = Vname

      const x = new XMLHttpRequest()
      x.open('GET', url, true)
      x.responseType = 'blob'
      x.onload = function () {
        const url = window.URL.createObjectURL(x.response)
        const a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()


      // window.open(url,'_blank');
    },
    // 文件预览
    openVideo(value) {
      this.imgVisbleURL = value
      this.showPreview = true
    },

    reloadWf(){
      console.log('保存前的刷新');
 this.$emit('editViewDataUpdate')
    },

    showOrderRemaek(){
      console.log("submitButton",this.submitButton)
      console.log("recallButton",this.recallButton)
      if(!this.recallButton){
        this.$message.warning('没有回访权限')
      }else {
        this.showOrderRemaekDialog = true;
      }
    },

    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    deleteRecalls(row){
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'deleteRecalls')
        this.formData.virtualBarcodeBillRecalls = this.formData.virtualBarcodeBillRecalls.filter(item => item.recallRemark !== row.recallRemark)
      })
    },

    getData() {
      // console.log('getData',this.dataId)
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.wkVirtualBarcodeBill.getDataUrl + this.dataId,
          method: 'get',
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data
          this.formData = data
          if (this.formData.stat != 5 && this.formData.virtualBarcode) {
            this.formData.virtualBarcodeFlag = '******'
          } else {
            this.formData.virtualBarcodeFlag = this.formData.virtualBarcode
          }
          if(this.formData.checkResult){
            this.virtualBarcodeBillCheck1.push(
              {"checkResult":this.formData.checkResult,
                "passReason":this.formData.passReason,
                "barcodeError":this.formData.barcodeError,
                "checkRemark":this.formData.checkRemark}
            )
          }
          if(this.formData.recheckResult){
            this.virtualBarcodeBillCheck2.push(
              {"recheckResult":this.formData.recheckResult,
                "recheckMachineReturn":this.formData.recheckMachineReturn,
                "recheckRemark":this.formData.recheckRemark,
                "barcodeError":this.formData.barcodeError}
            )
          }
          // this.callMobile1 = this.formData.siteMobile

          if (this.justShow) {

          } else {
            //this.orgValue = data.orgId
            this.loadProductOption1()
          }
          this.justShow = this.formData.stat != 1
        })
      }else {
        this.enabled = true;
        if (this.currentSiteData !== null){ //网点端
          console.log("this.currentSiteData",this.currentSiteData)
          this.formData.siteName = this.currentSiteData.userName
          this.formData.siteId = this.currentSiteData.id
          //this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
          this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
        }
      }
    },

    // 加载产品小类
    loadProductOption1() {
      this.formData.categoryName = this.formData.bigCategoryName
      if(this.formData.smallCategoryName != null && this.formData.smallCategoryName != ''){
        this.formData.categoryName = this.formData.bigCategoryName+"/"+this.formData.smallCategoryName
      }
    },
    upVideo(){
      this.$mask.open()

    },
    handleFileSuccess(res, file, fileList) {
      let url = res.data.url
      let fileName = file.name
      console.log(url, "url")
      console.log(fileName, "name")
      this.formData.fileList.push({
        fileName: fileName,
        fileUrl: url
      })
      this.$message({
          message: '附件上传成功',
          type: 'success'
        });
        this.$mask.close()
    },

    deleteFile(row) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        console.log(row, 'delete')
        this.formData.fileList = this.formData.fileList.filter(item => item.url !== row.url)
      })
    },

    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },

    followUpOrderRemark(data){
      this.showOrderRemaekDialog = false;
      if(data == 0){
        return;
      }
      console.log("回访数据",data)
      if (!this.formData.virtualBarcodeBillRecalls) {
        this.formData.virtualBarcodeBillRecalls = []
      }
      console.log("回访数据",data)
      let filter = this.formData.virtualBarcodeBillRecalls.filter(item => item.huiFangQingKuang !== data.huiFangQingKuang)
      filter.push(data)
      this.formData.virtualBarcodeBillRecalls = filter
      console.log("this.formData.virtualBarcodeBillRecalls",this.formData.virtualBarcodeBillRecalls)
    },

    editViewDataUpdate() {
      this.$emit('editViewDataUpdate')
      this.$emit('changeTab')
    },

    handlePreview(file) {
      console.log(file);
    },

    handleClose(e) {
      if(e==1){

      }else if(e==2){

      }
    },

    //抽屉关闭后改变父组件的visible的值
    closeD(v) {
      this.showConfirmDialog = false
      this.showCloseDialog = false
      this.showAuditDialog = false
      this.getData()
    },

    closeImgViewer() {
      this.dialogVisible = false
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrlList = [file.url]
      this.dialogVisible = true
    },

    handleImageChange(fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },

    showPreconditionDialogFunc() {
      if (this.formData.siteId !== '' && this.formData.siteId !== null)
        this.showOrderPop = true
      else
        this.$message.warning('请先选中网点')
    },

    checkSubjectSelectOne() {
      if (this.formData.checkSubjectId) {
        this.$http.post(api.basCheckSubject.getDataUrl, { id: this.formData.checkSubjectId }).then(res => {
          let data = res.data.data
          this.formData.standardAmount = data.standardAmount
          this.formData.feeAttributeName = data.feeAttributeName
          this.formData.feeAttributeId = data.feeAttributeId
          this.formData.isNeedSiteComplain = data.isNeedSiteComplain
        })
        console.log(this.formData)
        // this.processId = this.formData.processId;
        // console.log(this.processId,'this.processId的值');
      } else {
        this.formData.standardAmount = 0
        this.formData.feeAttributeName = null
        this.formData.feeAttributeId = null
        this.formData.isNeedSiteComplain = null
      }
    },

    //加载判断当前登录是否网点
    loadLoginIsSite() {
      this.$http({
        url: api.snUser.getLoginIsSite,
        method: 'post',
        data: {}
      }).then(res => {
        console.log("this.currentSiteData",this.currentSiteData)
        console.log("当前登录信息",res.data)
        if(res.data.data.userType != null){
          this.formData.siteMan = this.currentSiteData.snSiteInfoDTO.siteMan
          this.formData.siteMobile = this.currentSiteData.snSiteInfoDTO.siteManMobile
          //this.orgValue = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
          this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
          this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
          this.formData.siteName = this.currentSiteData.userName
          this.formData.siteId = this.currentSiteData.id

        }
      })
    },

    // 加载机构数据
    loadOrgData() {
      this.$http({
        url: api.sysDept.getDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        console.log(res.data.data)
        this.orgOptions = []
        res.data.data.forEach(item => {
          let temp = {
            value: item.id,
            label: item.name,
          }
          if (item.hasChild) {
            temp.children = []
            item.child.forEach(item1 => {
              temp.children.push({
                value: item1.deptId,
                label: item1.name
              })
            })
          }
          this.orgOptions.push(temp)
        })
      })
    },

    // 机构选中
    orgHandleChange(data) {
      if (data.length !== 0) {
        this.$http({
          url: '/admin/dept/' + data[data.length - 1],
          method: 'get'
        }).then(res => {
          console.log('选中机构', res.data.data)
          this.formData.orgId = res.data.data.deptId
          this.formData.orgName = res.data.data.name
          this.formData.orgIdPath = res.data.data.orgIdPath
        })
      }
    },

    //生成虚拟条码
    createVirtualBarcode(){
      if(this.formData.barcode == '' || this.formData.barcode == null){
        this.$message.warning("请先填写产品条码")
        return;
      }
      if (this.formData.barcode.length != 13) {
        this.$message.warning("请填写正确13位数条码(不能含有空格)")
        return;
      }
      this.$http({
        url: api.wkVirtualBarcodeBill.createVirtualBarcode,
        method: 'post',
        data: {barcode : this.formData.barcode}
      }).then(res => {
        console.log("生成虚拟条码",res.data.data)
        console.log(this.formData.virtualBarcode,"this.formData.virtualBarcode前值");
        this.$set(this.formData, 'virtualBarcodeFlag', "******")
        this.$set(this.formData, 'virtualBarcode', res.data.data)
        console.log(this.formData.virtualBarcode,"this.formData.virtualBarcode后值");
      }).catch(e => {
        this.$message.error("生成失败！"+e.message);
      })
    },


    //检查条码使用情况
    checkBarcode(){
      // if (!this.formData.barcode || (this.formData.stat != 1 && this.formData.stat != 6)) {
      if (!this.formData.barcode) {
        return false
      }
      if (!this.formData.orderNo) {
        this.$message.warning('工单号必填')
        return false
      }
      this.formData.barcode = this.formData.barcode.replace(/\s+/g, '')
      if (this.formData.barcode.length != 13) {
        this.$message.warning("请填写正确13位数条码(不能含有空格)")
        return;
      }
      this.$http({
        url: api.wkVirtualBarcodeBill.checkBarcode,
        method: 'post',
        data: {
          barcode: this.formData.barcode,
          orderNo: this.formData.orderNo,
        }
      }).then(res => {
        console.log(res.data.data)
        this.$set(this.formData, 'applyRemark', res.data.data['result'])
        this.$message.warning(res.data.data['result'])

        if (res.data.data['hasBarcode']) {
          // 如果已存在条码 且未被使用 则提示不能保存
          this.$message.warning("该条码已存在且未被使用, 不允许申请")
          this.hasBarcode = true
          return;
        } else {
          this.hasBarcode = false
        }

        // if (res.data.data == '系统找不到此条码') {
        if (res.data.data['hasItem']) {
          this.formData.itemId = res.data.data['itemId']
          this.formData.itemCode = res.data.data['itemCode']
          this.formData.itemName = res.data.data['itemName']
          this.formData.categoryName = res.data.data['bigCategoryName'] + (res.data.data['smallCategoryName'] ? ("/" + res.data.data['smallCategoryName']) : '')

          this.formData.bigCategoryName = res.data.data['bigCategoryName']
          this.formData.smallCategoryName = res.data.data['smallCategoryName']
          this.formData.bigCategoryId = res.data.data['bigCategoryId']
          this.formData.smallCategoryId = res.data.data['smallCategoryId']
        } else {
          this.searchItemButton = false
          this.formData.itemId = null
          this.formData.itemCode = ''
          this.formData.itemName = ''
          this.formData.categoryName = ''

          this.formData.bigCategoryName = ''
          this.formData.smallCategoryName = ''
          this.formData.bigCategoryId = null
          this.formData.smallCategoryId = null
        }
        // if (res.data.data['hasItem'] || res.data.data['result'] == '远程调用校验条码失败' || res.data.data['result'] == '系统找不到此条码' || res.data.data['result'] == 'ERP不存在条码') {
        //   this.searchItemButton = false
        // }
      })
    },

    saveData() {
      if (this.hasBarcode) {
        this.$message.warning("该条码已存在且未被使用, 不允许申请")
        return;
      }
      if(this.formData.fileList == null || this.formData.fileList.length == 0){
        this.$message.warning("请上传附件")
        return;
      }
      if (!this.formData.barcode) {
        this.$message.warning("请输入条码")
        return;
      }

      if (!this.formData.applyRemark) {
        this.$message.warning("请点击产品条码后再移开以带出检测结果")
        return;
      }
      this.formData.siteMobile = this.formData.siteMobile.replace(/\s+/g, '')
      if (this.formData.siteMobile.length > 20) {
        this.$message.warning("联系人电话过长")
        return;
      }
      this.formData.barcode = this.formData.barcode.replace(/\s+/g, '')
      if (this.formData.barcode.length != 13) {
        this.$message.warning("请填写正确13位数条码(不能含有空格)")
        return;
      }
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()
            // this.formData.siteMobile = this.callMobile1

            var method = (this.isEdit ? 'put' : 'post');
            var url = (this.isEdit ? api.wkVirtualBarcodeBill.updateDataUrl : api.wkVirtualBarcodeBill.addDataUrl);
            this.$http({
              url: url,
              method: method,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success('保存成功')
              this.reload()
              this.$mask.close()
            }).catch(() => {
              this.$message.error("保存失败！");
              this.$mask.close()
            });
          });
        }
      });
    },

    cancelForm() {
      this.loading = false;
      this.initiateAppeal = false;
      clearTimeout(this.timer);
    },

    // 工单弹窗选中
    orderCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.orderNo = row.orderNo
      this.formData.orderId = row.orderId
      this.formData.serviceTypeName = row.serviceTypeName
      this.formData.serverTypeId = row.serverTypeId
      this.formData.userName = row.userName
      this.formData.userMobile = row.userMobile
      this.formData.itemId = row.itemId
      this.formData.itemCode = row.itemCode
      this.formData.itemName = row.itemName
      this.formData.categoryName = row.bigCategoryName+"/"+row.smallCategoryName
      this.formData.bigCategoryName = row.bigCategoryName
      this.formData.smallCategoryName = row.smallCategoryName
      this.formData.bigCategoryId = row.bigCategoryId
      this.formData.smallCategoryId = row.smallCategoryId
      this.formData.barcode = row.resultBarcode
      this.formData.buyDate = row.buyDate

      this.barcodeChange()

      if (this.formData.barcode) {
        console.log('orderCommit this.checkBarcode()')
        this.checkBarcode()
      }
      // this.searchItemButton = true
    },

    // 网点弹窗选中
    siteCommit(row) {
      console.log(row, '弹窗数据')
      this.formData.siteId = row.id
      this.formData.siteName = row.name
      //this.orgValue = row.orgId
      this.formData.orgId = row.orgId
      this.formData.orgName = row.orgName
      this.formData.orgIdPath = row.orgIdPath
      this.formData.siteMan = row.siteMan
      this.formData.siteMobile = row.siteManMobile
    },
  },
};

</script>
<style lang="scss" scoped>
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 80px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 80px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 1px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  // border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 656px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  // background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}


#containt .detail-wrap .d-cont {
  overflow: unset !important;
  margin: 0 !important;
  padding: 0 !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

::v-deep .el-image {
  width: 60px;
}
.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
.Instructions {
  text-decoration: underline;
  color: #00c4b3;
  margin-left: 5px;
}
::v-deep .table-detail tbody tr td  {
  width: 13vw !important;

}
</style>
